import { trackEvent } from "@utils/tracking";
import type { PushNotificationClickedPayload } from "../resolvePushNotificationRoute";
import { PUSH_TYPE_TRACKER } from "../resolvePushNotificationRoute";

/**
 * Web Push 点击埋点（PRD §1.5 / §2.5 前端可观测部分）。
 * `push_sent` / `push_suppressed` 由后端上报；`push_received` 可选（Web 通常仅能观测 click）。
 */
export function trackPushNotificationClick(
  data: PushNotificationClickedPayload,
): void {
  const pushType = data.type ?? "";
  if (pushType.startsWith("fcm.title.recall.")) {
    trackEvent("recall_push_click", {
      recall_category: data.recall_category,
      goal_id: data.goalId,
      type: pushType,
    });
    return;
  }

  if (pushType === PUSH_TYPE_TRACKER) {
    const domain =
      data.domain === "plan" || data.domain === "invest"
        ? data.domain
        : "invest";
    const recordId = data.recordId ?? data.signalId;
    trackEvent("push_click", {
      domain,
      tracker_id: data.trackerId,
      signal_id: recordId,
      goal_id: data.goalId,
      signal_category: data.signal_category,
      event: data.event,
      type: pushType,
    });
  }
}
